export default {
    'Decimal': ()=> import("@/components/study/datafieldsReadonly/DecimalFieldReadonly.vue"),
    'LabValue': ()=> import("@/components/study/datafieldsReadonly/LabValueFieldReadonly.vue"),
    'Enumeration': ()=> import("@/components/study/datafieldsReadonly/EnumerationFieldReadonly.vue"),
    'CheckBox': ()=> import("@/components/study/datafieldsReadonly/CheckBoxFieldReadonly.vue"),
    'EventReportListEntry': ()=> import("@/components/study/datafieldsReadonly/EventReportListEntryFieldReadonly.vue"),
    'EventReportList': ()=> import("@/components/study/datafieldsReadonly/EventReportListFieldReadonly.vue"),
    'FieldGroup': ()=> import("@/components/study/datafieldsReadonly/FieldGroupReadonly.vue"),
    'Integer': ()=> import("@/components/study/datafieldsReadonly/IntegerFieldReadonly.vue"),
    'ListEntry': ()=> import("@/components/study/datafieldsReadonly/ListEntryFieldReadonly.vue"),
    'List': ()=> import("@/components/study/datafieldsReadonly/ListFieldReadonly.vue"),
    'MedicalDate': ()=> import("@/components/study/datafieldsReadonly/MedicalDateFieldReadonly.vue"),
    'Date': ()=> import("@/components/study/datafieldsReadonly/DateFieldReadonly.vue"),
    'Scale': ()=> import("@/components/study/datafieldsReadonly/ScaleFieldReadonly.vue"),
    'FreeText': ()=> import("@/components/study/datafieldsReadonly/TextFieldReadonly.vue"),
    'DisplayValue': () => import("@/components/study/datafieldsReadonly/DisplayValueFieldReadonly.vue"),
}
